import {React, useState, useEffect, useCallback} from 'react';
import "./Navbar.css"
import NavBarSideMobile from './NavBarSideMobile';
import NavBarTopMenu from './NavBarTopMenu';

const Navbar = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [showMenu, setShowMenu] = useState(false);


  const handleClick = ()=>{
    setShowMenu(!showMenu);
    //console.log("HAND");
  }

  const handleClickOutside = useCallback((event) => {
    const menuBar = document.querySelector('.menu-bar-mobile');
    const menuIcon = document.querySelector('.menu-icon');
    const menuButton = document.querySelector('.menu-btn');
    if (menuBar !== null) {
      menuBar.style.transition = "transform 0.7s ease-in-out"
    }

    if (isMobile && menuBar !== null && menuIcon !== null) {
    if (!menuIcon.contains(event.target) && event.target !== menuButton) {
      setShowMenu(false);
      return
    }
    }
  }, [isMobile]);

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [handleClickOutside, isMobile]);

  useEffect(() => {
    const element = document.querySelector(".menu-bar-mobile");
    if (element!==undefined && element!==null){
      element.style.transition = "transform 0.7s ease-in-out"
    }
    
      return
  }, []);
 
  useEffect(() => {
    setIsMobile(window.innerWidth <= 790);

    const handleResize = () => {
      setIsMobile(window.innerWidth <= 790);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

   return (
    <>
     <header className="header" style={isMobile?{justifyContent:"center"}:{justifyContent:"flex-end"}}>
     <input className="menu-btn" type="checkbox" id="menu-btn" checked={showMenu} readOnly/>
        <label className="menu-icon" style={!isMobile?{display:"none"}:{display:"unset", float:"right"}} onClick={handleClick} htmlFor="menu-btn">
          <span className="navicon"></span>
        </label>
        {isMobile?
         <NavBarSideMobile showMenu={showMenu}/>
        :
       <NavBarTopMenu showMenu={showMenu}/>
        }
        </header>
    </>
   )
};
  
export default Navbar;